import Game from './core/Game.js';
import { gameState } from './core/GameState.js';
import { eventBus, Events } from './core/EventBus.js';
import { ConfigPanel } from './ui/ConfigPanel.js';

const game = new Game();
const configPanel = new ConfigPanel(game);

// Handy for poking at balance values from the console during development.
if (import.meta.env?.DEV) {
  Object.assign(window, { __game: game, __state: gameState, __bus: eventBus, __events: Events, __config: configPanel });
}
